import React, { useEffect, useState } from 'react';
import { getDashboardStats } from '../services/dashboardService';
import './Dashboard.css';
import { useAuth } from '../context/AuthContext';

const Dashboard = () => {
  const { currentUser } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const data = await getDashboardStats();
        setStats(data.data); // `data.data` comes from API response
      } catch (err) {
        console.error('Failed to fetch dashboard stats:', err);
        setError('Failed to load dashboard stats');
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (loading) return <div className="message loading">Loading dashboard...</div>;
  if (error) return <div className="message error">{error}</div>;

  return (
    <div className="dashboard">
      <h1>Dashboard</h1>

      <div className="stats-container">
        <div className="stat-card blue">
          <div className="stat-content">
            <div className="stat-value">{stats.totalUsers}</div>
            <div className="stat-label">TOTAL USERS</div>
          </div>
          <div className="stat-icon">👤</div>
        </div>

        <div className="stat-card purple">
          <div className="stat-content">
            <div className="stat-value">{stats.totalVendors}</div>
            <div className="stat-label">TOTAL VENDORS</div>
          </div>
          <div className="stat-icon">🏬</div>
        </div>

        <div className="stat-card teal">
          <div className="stat-content">
            <div className="stat-value">{stats.totalItems}</div>
            <div className="stat-label">TOTAL ITEMS</div>
          </div>
          <div className="stat-icon">🧺</div>
        </div>

        <div className="stat-card green">
          <div className="stat-content">
            <div className="stat-value">{stats.totalCategories}</div>
            <div className="stat-label">TOTAL CATEGORIES</div>
          </div>
          <div className="stat-icon">📂</div>
        </div>

        <div className="stat-card orange">
          <div className="stat-content">
            <div className="stat-value">{stats.totalOrders}</div>
            <div className="stat-label">TOTAL ORDERS</div>
          </div>
          <div className="stat-icon">📦</div>
        </div>

        <div className="stat-card red">
          <div className="stat-content">
            <div className="stat-value">{stats.totalTasks}</div>
            <div className="stat-label">TOTAL TASKS</div>
          </div>
          <div className="stat-icon">✅</div>
        </div>

        <div className="stat-card blue">
          <div className="stat-content">
            <div className="stat-value">{stats.totalSOS}</div>
            <div className="stat-label">TOTAL SOS ALERTS</div>
          </div>
          <div className="stat-icon">🚨</div>
        </div>

        <div className="stat-card purple">
          <div className="stat-content">
            <div className="stat-value">{stats.totalVideos}</div>
            <div className="stat-label">TOTAL VIDEOS</div>
          </div>
          <div className="stat-icon">🎥</div>
        </div>

        <div className="stat-card teal">
          <div className="stat-content">
            <div className="stat-value">{stats.totalSpins}</div>
            <div className="stat-label">TOTAL USER SPINS</div>
          </div>
          <div className="stat-icon">🎰</div>
        </div>

        <div className="stat-card green">
          <div className="stat-content">
            <div className="stat-value">{stats.totalSpinOptions}</div>
            <div className="stat-label">ACTIVE SPIN OPTIONS</div>
          </div>
          <div className="stat-icon">⚙️</div>
        </div>

        <div className="stat-card orange">
          <div className="stat-content">
            <div className="stat-value">{stats.userWalletTotal}</div>
            <div className="stat-label">TOTAL USER WALLET</div>
          </div>
          <div className="stat-icon">💰</div>
        </div>

        <div className="stat-card red">
          <div className="stat-content">
            <div className="stat-value">{stats.vendorWalletTotal}</div>
            <div className="stat-label">TOTAL VENDOR WALLET</div>
          </div>
          <div className="stat-icon">🏦</div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;